import React from 'react';

function isInternalHref(href) {
  return href.startsWith('/') || href.startsWith('#');
}

export default function AppLink({
  href,
  onNavigate,
  className = '',
  active = false,
  children,
  ...props
}) {
  const handleClick = (event) => {
    if (props.target === '_blank' || !isInternalHref(href)) return;

    event.preventDefault();

    if (href === '#') {
      window.scrollTo({ top: 0, behavior: 'smooth' });
      return;
    }

    if (href.startsWith('#')) {
      const target = document.querySelector(href);
      if (target) {
        target.scrollIntoView({ behavior: 'smooth', block: 'start' });
      }
      return;
    }

    if (onNavigate) {
      onNavigate(href);
      return;
    }

    window.history.pushState({}, '', href);
    window.dispatchEvent(new PopStateEvent('popstate'));
  };

  return (
    <a
      href={href}
      className={`${className} ${active ? 'is-active' : ''}`.trim()}
      onClick={handleClick}
      {...props}
    >
      {children}
    </a>
  );
}
